'use client';

import classnames from 'classnames/bind';
import { useTranslations } from 'next-intl';
import { NavigationItem } from './_components/navigation-item';
import { useArticleNavigation } from './_hooks/use-article-navigation';
import { useIsDesktop } from './_hooks/use-is-desktop';
import styles from './index.module.scss';

const BLOCK_NAME = 'Side-navigation';
const cn = classnames.bind(styles);
const HEADING_INDENT = 20;

type TProps = {
  title: string;
  materialId: string;
};

export const SideNavigation = ({ title, materialId }: TProps) => {
  const translations = useTranslations('article');
  const isDesktop = useIsDesktop();
  const { railRef, headings, activeHeading, selectHeading } =
    useArticleNavigation({
      materialId,
      title,
    });

  return (
    <aside
      ref={railRef}
      className={cn(BLOCK_NAME, {
        [`${BLOCK_NAME}--empty`]: !headings.length,
      })}
    >
      {headings.length > 0 && (
        <nav
          aria-label={translations('navigationTitle')}
          className={cn(`${BLOCK_NAME}__navigation`)}
        >
          <div className={cn(`${BLOCK_NAME}__title`)}>
            <NavigationItem
              isDesktop={isDesktop}
              isActive={activeHeading === null}
              onNavigate={selectHeading}
              text={title}
            />
          </div>
          {headings.map(({ element, text, indent }, index) => (
            <div
              key={`${element.id}-${index}`}
              style={{
                paddingInlineStart: indent * HEADING_INDENT,
              }}
            >
              <NavigationItem
                element={element}
                isDesktop={isDesktop}
                isActive={activeHeading === element}
                onNavigate={selectHeading}
                text={text}
              />
            </div>
          ))}
        </nav>
      )}
    </aside>
  );
};
